module.exports = __webpack_public_path__ + "static/img/gws-logo-new.45e22b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gws-logo-new.png
// module id = 4sXV
// module chunks = 1